
import { Component, Vue } from 'vue-property-decorator';

import { getModule } from 'vuex-module-decorators';

import HomeStore from '@/store/modules/home.module';

import { Subtitle } from '@atoms';

import { Grid } from '@bosons';

import { TasksState } from '@molecules';

@Component({
  components: {
    Grid,
    Subtitle,
    TasksState,
  },
})
export default class HomeBody extends Vue {
  homeStore = getModule(HomeStore, this.$store);

  get tasks() {
    return this.homeStore.tasks.filter((task) => !task.check);
  }

  get tasksCompleted() {
    return this.homeStore.tasks.filter((task) => task.check);
  }
}
